
export class UserModel {
    id: string;
    principalDisplayName: string;
    resourceDisplayName: string;
    userRoleName: string;
    userRoleDescription: string;     
    email: string; 
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/UserModel.ts